import fb from "../../assets/svg-icons/social/facebook.svg";
import insta from "../../assets/svg-icons/social/instagram.svg";
import snap from "../../assets/svg-icons/social/snap.svg";
import tiktok from "../../assets/svg-icons/social/tiktok.svg";
import twitter from "../../assets/svg-icons/social/twitter.svg";
import yt from "../../assets/svg-icons/social/youtube.svg";

const socialData = [
    {
        id: "s_1",
        title: "instagram",
        link: "#",
        icon: insta
    },
    {
        id: "s_2",
        title: "facebook",
        link: "#",
        icon: fb
    },
    {
        id: "s_3",
        title: "twitter",
        link: "#",
        icon: twitter
    },
    {
        id: "s_4",
        title: "youtube",
        link: "#",
        icon: yt
    },
    {
        id: "s_5",
        title: "tikok",
        link: "#",
        icon: tiktok
    },
    {
        id: "s_6",
        title: "snap chat",
        link: "#",
        icon: snap
    }
];

export default socialData;
